<template>
<div id="PickByBin" class="row">
    <TabNav :tabs="['Pick By Bin', 'Sales Orders', 'Scanned Skus']" :selected="selected" @selected="setSelected" >
      <Tab :isSelected="selected === 'Scanned Skus'">
          <ScannedSkus @set-selected='setSelected' />
      </Tab>
      <Tab :isSelected="selected === 'Sales Orders'">
          <SalesOrders @set-selected='setSelected' />
      </Tab>
      <Tab :isSelected="selected === 'Pick By Bin'"  >
        <Pbb @set-selected='setSelected' />
      </Tab>

    </TabNav>
  </div>
</template>

<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'
  import Pbb from './Xfer/Pbb'
  import ScannedSkus from './Xfer/ScannedSkus'
  import SalesOrders from './Xfer/SalesOrders'

  export default {
    name: 'PickByBin',
    components: {
      TabNav,
      Tab,
      Pbb,
      ScannedSkus,
      SalesOrders
    },
    mounted() {
      this.isPowerScan = true;
    },
    data() {
      return {
        skuToPick : '',
        selected : 'Pick By Bin',
        customerName : 'Dillard\'s',
        soNumber : '0293489340',
        customerPoNumber : 'PREPAY',
        isPowerScan: this.$store.getters['Navigation/isPowerScan'],
        binInformation : [
          {
            bin : 'REC-A2',
            qty : 8,
          },
          {
            bin : 'REC-B5',
            qty : 10,
          },
        ],
        itemsInBin : [
          {
            sku : 'Q6B00G39NB000',
            description : 'Stephen Sprouse x LV Monogram Graffiti Neverfull GM',
            img : 'https://www.whatgoesaroundnyc.com/media/catalog/product/cache/0f277441d5906fc2420df69ac5fa34d6/Q/G/QGB10G12YB000_1.webp'
          }
        ]
      }
    },
    methods: {
      setSelected(tab) {
        this.selected = tab
      },
      totalNumberOfItems() {
        let total = 0;
        this.binInformation.forEach(item => {
          total += item.qty
        })
        return total;
      }
    },
  }
</script>